import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import LeftIcon from '@upright/ui/icons/img/streamline-mini-line/interface-essential/arrows/interface-arrows-button-left.svg';
import RightIcon from '@upright/ui/icons/img/streamline-mini-line/interface-essential/arrows/interface-arrows-button-right.svg';
import styled from 'styled-components';

interface Props {
  index: number;
  total: number;
  setIndex: (index: number) => void;
}

export function InfoBoxStepper(props: Props) {
  const { index, total, setIndex } = props;
  const canStepNext = index < total - 1;
  const canStepPrev = index > 0;

  if (total === 1) {
    return <></>;
  }

  return (
    <Root>
      {total !== 1 && (
        <LeftIcon
          stroke={canStepPrev ? 'currentColor' : BouColor.TOOL_TEXT_DARK_GRAY}
          style={{
            height: '0.8em',
            width: '0.8em',
            marginRight: '0.5em',
            cursor: canStepPrev ? 'pointer' : undefined,
            strokeWidth: 1.5,
          }}
          onClick={() => {
            if (canStepPrev) {
              setIndex(index - 1);
            }
          }}
        />
      )}
      <Count>
        {index + 1}/{total}
      </Count>
      {total !== 1 && (
        <RightIcon
          stroke={canStepNext ? 'currentColor' : BouColor.TOOL_TEXT_DARK_GRAY}
          style={{
            height: '0.8em',
            width: '0.8em',
            marginLeft: '0.5em',
            cursor: canStepNext ? 'pointer' : undefined,
            strokeWidth: 1.5,
          }}
          onClick={() => {
            if (canStepNext) {
              setIndex(index + 1);
            }
          }}
        />
      )}
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Count = styled.div``;
